import { format, isValid } from 'date-fns';

export function formatISOStringToDateString(date: string): string {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function formatDateToDateString(date: Date): string {
  return formatISOStringToDateString(date.toISOString());
}

export function resetTimeInDate(value: string | number | Date): Date {
  const date = new Date(value);
  if (!isValid(date)) {
    throw new Error('Invalid date provided for time reset!');
  }

  // Set time to midday
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
}
